<template>
    <v-tab-item :value="Sampling.value">
        <v-container>
            <top-image :tit="Sampling.text" bgImage="/images/sub/product/sampling-bg.jpg" image="/images/sub/product/sampling-img.jpg">
                <p class="page-text mb-6 mb-lg-20">
                    Our Sampling System is designed to provide the highest level of performance and accuracy, ensuring that your samples are prepared and analyzed to the highest standard. Whether you
                    need to meet strict regulatory requirements or need to handle complex samples, our sample handling system can be customized to meet your specific needs and deliver the results you
                    need.
                </p>
                <p class="page-text">
                    In addition, the system can be integrated with a variety of online analyzers, including mass spectrometers, gas chromatographs, and other analytical instruments. This allows for
                    seamless sample preparation and analysis, resulting in high-quality data and accurate results.
                </p>
            </top-image>
        </v-container>
    </v-tab-item>
</template>

<script>
import TopImage from "@/components/dumb/top-image.vue";
import { Product_TABS } from "@/assets/variables";
const { Sampling } = Product_TABS;
export default {
    components: {
        TopImage,
    },
    data() {
        return {
            Sampling,
        };
    },
};
</script>

<style scoped></style>
